import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ZorroTableComponent } from "../../../../../components/common/custom-table/zorro-table.component";
import { LoadingComponent } from "../../../../../components/common/loading/loading.component";
import { ComparisonCardComponent } from "../../../../../components/comparison-card/comparison-card.component";
import { RestTcoService } from "../../../../../core/services/rest-tco.service";
import { uniqueTestCaseTableColumns } from "../../../../../core/table-templates/unique-test-cases-table";

@Component({
  selector: "app-unique-test-cases",
  standalone: true,
  imports: [ZorroTableComponent, CommonModule, ComparisonCardComponent, LoadingComponent],
  templateUrl: "./unique-test-cases.component.html",
  styleUrl: "./unique-test-cases.component.scss",
})
export class UniqueTestCasesComponent implements OnInit {
  @Input() data: any[] = [];
  @Input() modelId: any;
  @Output() moveToPreviousTabEvent = new EventEmitter<void>();

  columns: any = uniqueTestCaseTableColumns;
  testArray: any = [];
  selectedRows: any = [];
  selectedRowsComparison: any = [];
  isDisabled:boolean = true;
  isLoading:boolean = false;

  colors: any = [
    {
      bg: "rgba(47, 118, 255, 0.05)",
      border: "rgba(47, 118, 255, 1)",
    },
    {
      bg: "rgba(168, 37, 219, 0.05)",
      border: "rgba(168, 37, 219, 1)",
    },
  ];
  selectedTestId: number[] = [];
  isHeaderChecked: any;

  constructor(private restTcoService: RestTcoService) {}

  ngOnInit(): void {
    this.getdata();
  }

  handleRowSelection(event: any) {
    if (event?.data) {
      this.selectedRows = event.data;
    }

    if(this.selectedRows.length > 1 && this.selectedRows.length < 4){
      this.isDisabled = false;
    }else{
      this.isDisabled = true;
    }
  }

  compare() {
    this.selectedRowsComparison = [];
    this.selectedRows.forEach((item: any) => {
      var data = {
        id: item?.testId,
        steps: this.formatSteps(item.corStepDesc),
        results: this.formatSteps(item.cleanedExpResult),
      };

      this.selectedRowsComparison.push(data);
    });
  }

  getColor(ind: number) {
    let targetInd = ind % 2;
    return this.colors[targetInd];
  }

  // Function to get the selected items
  getSelectedItems() {
    return this.testArray.filter((item: any) => item.checked);
  }

  truncateText(text: string, wordLimit: number): string {
    const words = text.split(" ");
    if (words.length <= wordLimit) {
      return text;
    }
    return words.slice(0, wordLimit).join(" ") + "...";
  }

  getdata() {
    this.isLoading = true;
    if (this.modelId) {
      this.restTcoService
        .getUniqueTestCases(this.modelId)
        .subscribe((response) => {
          this.isLoading = false;
          console.log("response", response);
          this.testArray = response;
          this.testArray = response.map((item: any, index: number) => ({
            ...item,
            sno: index + 1,
          }));
          console.log("Testcase data", this.testArray);
        }, (error)=>{
          this.isLoading = false;
          console.log("error", error);
        });
    }
  }

  formatSteps(description: string): string[] {
    if (!description.startsWith("Step")) {
      return [description];
    }

    const steps = description.split("Step");
    steps.shift(); // Remove the empty first element

    const formattedSteps = steps.map((step) => {
      const lines = step.split(/\n/);
      const formattedSubSteps = lines.map((line, index) => {
        if (index === 0) {
          return `Step ${line.trim()}`;
        } else {
          return `\t${line.trim()}`;
        }
      });
      return formattedSubSteps.join("\n");
    });

    return formattedSteps;
  }
  downloadUniquesCSV() {
    // Convert the data to a CSV format
    const csvData = this.testArray.map((item: any) => [
      `"${item.testId}"`,
      `"${item.testName.replace(/"/g, '""').replace(/[\n\r]/g, "")}"`,
      `"${item.corStepDesc.replace(/"/g, '""').replace(/[\n\r]/g, "")}"`,
      `"${item.cleanedExpResult.replace(/"/g, '""').replace(/[\n\r]/g, "")}"`,
      `"${item.description.replace(/"/g, '""').replace(/[\n\r]/g, "")}"`,
    ]);

    const csvString =
      "testId,testName,corStepDesc,cleanedExpResult,description\n" +
      csvData.map((row: any) => row.join(",")).join("\n");

    const blob = new Blob([csvString], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "UniqueTestcases.csv";
    a.click();
    window.URL.revokeObjectURL(url);
  }
goBack() {
  this.moveToPreviousTabEvent.emit();
}
}
